/* En-tête collant — pose `est-defile` dès que la page a bougé.
   Écouteur PASSIF et throttlé par requestAnimationFrame : le
   défilement ne doit rien coûter. On ne lit `scrollY` qu'une fois
   par image, et on n'écrit la classe que lorsqu'elle change. */
(function () {
  var chrome = document.querySelector('[data-v5chrome]');
  if (!chrome) return;
  var SEUIL = 8;
  var enCours = false;
  var etat = null;

  function mesurer() {
    enCours = false;
    var defile = window.scrollY > SEUIL;
    if (defile === etat) return;
    etat = defile;
    chrome.classList.toggle('est-defile', defile);
  }

  function auDefilement() {
    if (enCours) return;
    enCours = true;
    window.requestAnimationFrame(mesurer);
  }

  window.addEventListener('scroll', auDefilement, { passive: true });
  mesurer();
})();
